function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
module.exports = function (priceTaxFeeAdjusterBase, purchaseService, feebusterService) {
  var priceTaxFeeAdjuster = /*#__PURE__*/function (_priceTaxFeeAdjusterB) {
    function priceTaxFeeAdjuster(supplementalData) {
      var _this;
      _classCallCheck(this, priceTaxFeeAdjuster);
      _this = _callSuper(this, priceTaxFeeAdjuster, [supplementalData]);
      _this.name = "promo";
      _this.id = priceTaxFeeAdjuster.nextId;
      priceTaxFeeAdjuster.nextId++;
      _this.supplementalData = supplementalData;
      _this.priority = priceTaxFeeAdjuster.taxPriority + (supplementalData.positioning === "pretax" ? -200 : 200);
      _this.roundByGroup = "price";
      _this.groupIdPath = "extra.promo.id";
      return _this;
    }
    _inherits(priceTaxFeeAdjuster, _priceTaxFeeAdjusterB);
    return _createClass(priceTaxFeeAdjuster, [{
      key: "calculatePotentialBrOnly",
      value: function calculatePotentialBrOnly(copyOfProductlist) {
        this.calculate(copyOfProductlist, true);
      }
    }, {
      key: "calculate",
      value: function calculate(productlist, brMembershipDryRun) {
        var _this2 = this;
        var promodata = this.supplementalData.promos || [];
        var feebusterCoef = (purchaseService.feeBusterConfig.fraction || 0) + 1;
        if (brMembershipDryRun) {
          promodata = promodata.filter(function (a) {
            return a.extpromoid || a.promorequirebr;
          });
        }
        var purchaseProductlist = productlist.filter(function (a) {
          return !a.ispayment && !a.refund && !a.isFree;
        });
        var refundProductlist = productlist.filter(function (a) {
          return !a.ispayment && a.refund && !a.isFree;
        });

        // splice out all priceTaxFeeAdjustments of the type that this function will create before recalc otherwise we'll get two with the same name/id
        var _iterator = _createForOfIteratorHelper(productlist),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var p = _step.value;
            if (p.priceTaxFeeAdjustments && p.priceTaxFeeAdjustments.length) {
              p.priceTaxFeeAdjustments = p.priceTaxFeeAdjustments.filter(function (a) {
                return !(a.name === _this2.name && a.id === _this2.id);
              });
            }
          }

          // we need to go through the whole process treating purchases and refunds as two completely separate entities
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        [purchaseProductlist, refundProductlist].forEach(function (productlist) {
          // we shall name our loops because somtimes we need to break out of one and sometimes out of two
          var _iterator2 = _createForOfIteratorHelper(promodata),
            _step2;
          try {
            var _loop = function _loop() {
                var promo = _step2.value;
                if (!purchaseService.reg.brnumber && !brMembershipDryRun && (
                // if current customer has not been logged in as a BR Club member, and it's not a dry run and...
                promo.extpromoid ||
                // ...this is a BR promo, or...
                promo.promorequirebr) // ...the store owner has set all promos to require BR membership...
                ) {
                  return 0; // continue
                  // ... then move on to process the next promo
                }
                applicableProductlist = productlist.filter(function (a) {
                  return promo.upcs.includes(a.upc);
                });
                var promoQty = promo.pricing.qty;
                var promoCents = promo.pricing.cents;
                var tier = 0;
                var mustbuyquantity = promo.type.match(/^(mbq|mpr|mpo)-/);
                if (mustbuyquantity && promoQty) {
                  totalEligibleQtyInBasket = applicableProductlist.filter(function (a) {
                    return !a.refund;
                  }).reduce(function (total, a) {
                    return total + a.effectiveQuantity;
                  }, 0);
                  totalEligibleQtyInBasketRefund = applicableProductlist.filter(function (a) {
                    return a.refund;
                  }).reduce(function (total, a) {
                    return total + a.effectiveQuantity;
                  }, 0);
                }
                if (promo.type === "mbq-discount" && promo.extension && promo.extension.tiers && promo.extension.tiers.length) {
                  promo.extension.tiers.some(function (t, i) {
                    if (totalEligibleQtyInBasket >= t.qty) {
                      promoQty = t.qty;
                      promoCents = t.cents;
                      tier = i + 1;
                    } else {
                      return true;
                    }
                  });
                }

                // if it's valid, now apply the promo to each product, checking if applicable
                products: for (index = 0; p = applicableProductlist[index]; ++index) {
                  var addFeebuster = false;

                  // first make sure that, if "maxpb" is set for the promo (maximum allowed price for the item), that the price of this item does not exceed this value
                  if (promo.maxpb) {
                    var realItemPrice = p.getPrice() / p.qty;

                    /*********************
                     * When verifying maxprice, and the product in question is one whose price includes tax or fees, it should not consider them but rather deduct them from the base unit price.
                     * In the original code, purchaseService.calculatetax was used to calculate the tax to deduct from the base price.
                     * This would seem to produce wrong results as that function also considers EBT and reduces it from the base price.
                     * Yet this should not be a concertn of the promo, as all we care about is the list price this merchant gave the product to see if he is eligible for the promo, not any other manipulations that were done as the result of a sale.
                     *********************/
                    if (p.taxinc) {
                      var taxRules = p.revauths.filter(function (a) {
                        return a.type === "Tax";
                      });
                      var _iterator3 = _createForOfIteratorHelper(taxRules),
                        _step3;
                      try {
                        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                          var taxRule = _step3.value;
                          var taxFraction = taxRule.rate_decibps / 100000;
                          var taxAmount = realItemPrice * taxFraction;
                          realItemPrice -= taxAmount;
                        }
                      } catch (err) {
                        _iterator3.e(err);
                      } finally {
                        _iterator3.f();
                      }
                      var feeRules = p.revauths.filter(function (a) {
                        return a.type === "Fee";
                      });
                      var _iterator4 = _createForOfIteratorHelper(feeRules),
                        _step4;
                      try {
                        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                          var feeRule = _step4.value;
                          if (feeRule.taxable) {
                            var _iterator5 = _createForOfIteratorHelper(taxRules),
                              _step5;
                            try {
                              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                                var _taxRule = _step5.value;
                                var _taxFraction = _taxRule.rate_decibps / 100000;
                                var _taxAmount = feeRule.per_item_cents * _taxFraction;
                                realItemPrice -= _taxAmount;
                              }
                            } catch (err) {
                              _iterator5.e(err);
                            } finally {
                              _iterator5.f();
                            }
                          }
                        }
                      } catch (err) {
                        _iterator4.e(err);
                      } finally {
                        _iterator4.f();
                      }
                    }
                    if (p.feeinc) {
                      var _feeRules = p.revauths.filter(function (a) {
                        return a.type === "Fee";
                      });
                      var _iterator6 = _createForOfIteratorHelper(_feeRules),
                        _step6;
                      try {
                        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                          var _feeRule = _step6.value;
                          realItemPrice -= _feeRule.per_item_cents;
                        }
                      } catch (err) {
                        _iterator6.e(err);
                      } finally {
                        _iterator6.f();
                      }
                    }
                    if (realItemPrice > promo.maxpb) {
                      continue products;
                    }
                  }

                  // if must buy quantity ("mbq-") check that sufficient quantity has been reached for this offer in this basket in total - calculating purchases and refunds separately
                  if (mustbuyquantity && promoQty) {
                    totalEligibleQtyInBasket = p.refund ? totalEligibleQtyInBasketRefund : totalEligibleQtyInBasket;
                    if (totalEligibleQtyInBasket < promoQty) {
                      return 1; // continue promos
                      // no point going through any more products so just move on to the next promo
                    }
                  }
                  itemsImplicatedByPromoUpToThisProduct = applicableProductlist.slice(0, index).filter(function (a) {
                    return a.refund === p.refund;
                  });
                  offerQtyExcercisedForThisPromoUpToNotIncludingThisProduct = itemsImplicatedByPromoUpToThisProduct.reduce(function (total, a) {
                    return total + a.effectiveQuantity;
                  }, 0);
                  /********************************************************************************************
                   * check that maxoffers has not been reached for this offer in this basket up until this item
                   * adjust_extpromos already takes care of making sure the maxoffers value is adjusted by cloud records of offer use by this user if he is a BR member and this is a BR offer
                   ********************************************************************************************/
                  // maxoffers refers to how many times the totality of the promo may be redeemed not how many units may be bought
                  unitOffers = promo.maxoffers * (promo.type.match(/^mpr-/) ? 1 : promoQty);
                  if (unitOffers && offerQtyExcercisedForThisPromoUpToNotIncludingThisProduct >= unitOffers) {
                    return 1; // continue promos
                    // no point going through any more products so just move on to the next promo
                  }
                  promoType = promo.type.replace(/^(mbq|mpr|mpo)-/, "");
                  eligibleQtyInItem = unitOffers ? Math.min(unitOffers - offerQtyExcercisedForThisPromoUpToNotIncludingThisProduct, p.effectiveQuantity) : p.effectiveQuantity;
                  quantityThatCanAbsorbPromo = 0;
                  if (mustbuyquantity) {
                    // mbq discount work in groups - after buying sufficient quantity you must meet that quantity again to be re-eligible for the next products
                    // any products over the multiple are out
                    unusableQtyInThisItem = (offerQtyExcercisedForThisPromoUpToNotIncludingThisProduct + eligibleQtyInItem) % (promo.type.match(/^mbq-/) ? promoQty : 1);
                    quantityThatCanAbsorbPromoInThisItem = eligibleQtyInItem - unusableQtyInThisItem; // but you've stil got qty left after removing the top surplus that means you must have had some surplus from this and / or the previous item to remain with an eligible quantity
                    // so you can keep all this plus any surplus from the previous item
                    if (quantityThatCanAbsorbPromoInThisItem) {
                      UnusedQtyFromPreviousItems = offerQtyExcercisedForThisPromoUpToNotIncludingThisProduct % (promo.type.match(/^mbq-/) ? promoQty : 1);
                      quantityThatCanAbsorbPromo = quantityThatCanAbsorbPromoInThisItem + UnusedQtyFromPreviousItems;
                    }
                  } else {
                    quantityThatCanAbsorbPromo = eligibleQtyInItem;
                  }
                  if (!quantityThatCanAbsorbPromo) {
                    continue products;
                  }
                  // promo applies to the item price without the modifiers
                  unitPrice = Math.abs(p.getPrice()) / p.effectiveQuantity;
                  qtyAffected = quantityThatCanAbsorbPromo;
                  if (mustbuyquantity) {
                    quantityBalance = quantityThatCanAbsorbPromo - quantityThatCanAbsorbPromoInThisItem;
                    priceOfQtyOfThisProductThatCanAbsorbPromo = quantityThatCanAbsorbPromoInThisItem * unitPrice;
                    totalPrePromoPriceOfQuantityThatCanAbsorbPromo = priceOfQtyOfThisProductThatCanAbsorbPromo;
                    for (i = itemsImplicatedByPromoUpToThisProduct.length - 1; i >= 0; --i) {
                      if (!quantityBalance) {
                        break;
                      }
                      var _p = itemsImplicatedByPromoUpToThisProduct[i];
                      var _quantityThatCanAbsorbPromoInThisItem = Math.min(quantityBalance, _p.effectiveQuantity);
                      var _unitPrice = Math.abs(_p.getPrice()) / _p.qty;
                      var _priceOfQtyOfThisProductThatCanAbsorbPromo = _quantityThatCanAbsorbPromoInThisItem * _unitPrice;
                      totalPrePromoPriceOfQuantityThatCanAbsorbPromo += _priceOfQtyOfThisProductThatCanAbsorbPromo;
                      quantityBalance -= _quantityThatCanAbsorbPromoInThisItem;
                    }
                    qtyAffected = quantityThatCanAbsorbPromoInThisItem;
                  } else if (promoType === "price") {
                    totalPrePromoPriceOfQuantityThatCanAbsorbPromo = unitPrice * quantityThatCanAbsorbPromo;
                  }
                  switch (promoType) {
                    /*********************
                     * when promo.type is "price", the promo aims to set a new price for this product
                     * so the discount is the gain in the difference between the two prices
                     * note: pricing.cents is the new price on the totality of pricing.qty!
                     * so if it's a 4-pack and you only by one, the new price is pricing.cents / pricing.qty!
                     *********************/
                    case "price":
                      if (p.priceTaxFeeAdjustments && feebusterService.productPriceMustBeIncreased(p)) {
                        var feebusterPtf = p.priceTaxFeeAdjustments.find(function (a) {
                          return a.name === "feebuster";
                        });
                        if (feebusterPtf && feebusterPtf.price) {
                          addFeebuster = true;
                        }
                      }
                      unitPromoPrice = promo.pricing.cents * (addFeebuster ? feebusterCoef : 1) / promoQty;
                      costBenefit = totalPrePromoPriceOfQuantityThatCanAbsorbPromo - unitPromoPrice * quantityThatCanAbsorbPromo;
                      break;

                    /*********************
                     * when promo.type is "discount", the promo takes an amount off the price
                     * so the discount is the gain in the result of the amount for all eligible products
                     *********************/
                    case "discount":
                      var divisorQuantity = promo.type.match(/^mpr-/) ? 1 : promoQty;
                      unitPromoDiscount = promoCents / divisorQuantity;
                      costBenefit = unitPromoDiscount * quantityThatCanAbsorbPromo;
                      break;

                    /*********************
                     * when promo.type is "percentdiscount", the promo takes a fraction off the price
                     * so the discount is the gain in the result of the fraction for all eligible products
                     *********************/
                    case "percentdiscount":
                      if (mustbuyquantity) {
                        costBenefit = totalPrePromoPriceOfQuantityThatCanAbsorbPromo * promo.pricing.cents / 100;
                      } else {
                        var _realItemPrice = unitPrice;
                        unitPromoDiscount = _realItemPrice * (promo.pricing.cents / 100);
                        costBenefit = unitPromoDiscount * quantityThatCanAbsorbPromo;
                      }
                      break;
                    default:
                      console.error("unhandled promo type " + promoType);
                      return 1; // continue promos
                  }
                  p.priceTaxFeeAdjustments = p.priceTaxFeeAdjustments || [];
                  var promoPtf = {
                    name: _this2.name,
                    id: _this2.id,
                    priority: _this2.priority,
                    price: -costBenefit,
                    tax: 0,
                    fee: 0,
                    extra: {
                      promo: promo,
                      qtyAffected: qtyAffected,
                      tier: {
                        level: tier,
                        qty: promoQty,
                        cents: promoCents
                      },
                      addFeebuster: addFeebuster
                    }
                  };
                  p.priceTaxFeeAdjustments.push(promoPtf);

                  // if this promo is a new-price promo and it's price is fee-buster increased
                  // its PTF will need splitting up into base and feebuster components for correct reporting
                  // otherwise feebuster stats will not take into account the decrease caused by the promo
                  // we only apply this once we are in a child shadow item (as created by feebuster PTF)
                  // because if the child exists, then the parent must already exist, but not vice versa
                  if (p.cashPrice === true) {
                    var parentPromoPtfs = p.source.priceTaxFeeAdjustments.filter(function (a) {
                      return a.name === _this2.name && a.id === _this2.id;
                    });
                    // it will definitely have a promo ptf like this one eventually, it just may not be created yet
                    // so we will catch it at the next digest loop
                    var mainPromoPtf = parentPromoPtfs.find(function (a) {
                      return a.extra.addFeebuster;
                    });
                    var feebusterPromoPtf = parentPromoPtfs.find(function (a) {
                      return a.extra.feeBuster;
                    });
                    if (mainPromoPtf && !feebusterPromoPtf) {
                      var netFeeBusterPromoReduction = mainPromoPtf.price - promoPtf.price;
                      mainPromoPtf.price -= netFeeBusterPromoReduction;
                      var feeBusterPromoPtf = {
                        name: mainPromoPtf.name,
                        id: mainPromoPtf.id,
                        priority: mainPromoPtf.priority,
                        price: netFeeBusterPromoReduction,
                        tax: 0,
                        fee: 0,
                        extra: {
                          feeBuster: true,
                          promo: promo,
                          qtyAffected: qtyAffected,
                          tier: {
                            level: tier,
                            qty: promoQty,
                            cents: promoCents
                          }
                        }
                      };
                      p.source.priceTaxFeeAdjustments.push(feeBusterPromoPtf);
                    }
                  }
                }
              },
              applicableProductlist,
              totalEligibleQtyInBasket,
              totalEligibleQtyInBasketRefund,
              index,
              p,
              totalEligibleQtyInBasket,
              itemsImplicatedByPromoUpToThisProduct,
              offerQtyExcercisedForThisPromoUpToNotIncludingThisProduct,
              unitOffers,
              promoType,
              eligibleQtyInItem,
              quantityThatCanAbsorbPromo,
              unusableQtyInThisItem,
              quantityThatCanAbsorbPromoInThisItem,
              UnusedQtyFromPreviousItems,
              costBenefit,
              unitPrice,
              qtyAffected,
              quantityBalance,
              priceOfQtyOfThisProductThatCanAbsorbPromo,
              totalPrePromoPriceOfQuantityThatCanAbsorbPromo,
              i,
              qtyAffected,
              unitPromoPrice,
              unitPromoDiscount,
              unitPromoDiscount,
              _ret;
            promos: for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _ret = _loop();
              if (_ret === 0) continue;
              if (_ret === 1) continue promos;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        });
      }
    }, {
      key: "setSupplementalData",
      value: function setSupplementalData(supplementalData) {
        this.supplementalData = supplementalData;
      }
    }]);
  }(priceTaxFeeAdjusterBase);
  priceTaxFeeAdjuster.nextId = 0;
  priceTaxFeeAdjuster.taxPriority = 0; // so positive priorities are post-tax adjusters and negative values are pre-tax

  return {
    priceTaxFeeAdjuster: priceTaxFeeAdjuster
  };
}(require("../base.js"), require("../../purchaseservice.js"), require("../../module/PTFs/feebuster.js"));